import ko from 'knockout';
import buildKeyHandler from "./buildKeyHandler";

ko.bindingHandlers['escKey'] = buildKeyHandler(27);
